module.exports = __webpack_public_path__ + "img/IMG_9124.4adbc697.jpg";